/**
 * Calculates the device name based on the
 * ranges of viewport widths.
 *
 * @param {Object} hcStorage HC applicant data object
 */
function getDeviceByViewportWidth(hcStorage) {
  // Get device based on viewport width
  const viewportWidth = window.screen.availWidth;
  let deviceFound = 'Desktop';

  if (viewportWidth <= 720) {
    deviceFound = 'Mobile';
  } else if (viewportWidth > 720 && viewportWidth <= 1024) {
    deviceFound = 'Tablet';
  }

  if (hcStorage.Device !== deviceFound) {
    hcStorage.Device = deviceFound;
  }
}

export default getDeviceByViewportWidth;
